import { createApiCall } from 'lib/base';

const DELETE_STAFF_ACCOUNT = 'DELETE_STAFF_ACCOUNT';

export const deleteStaffAccountApi = createApiCall<{ id: string }>(
  DELETE_STAFF_ACCOUNT,
  ({ id }) => ({
    endpoint: `api/admin/staff-accounts/${id}`,
    method: 'DELETE',
  })
);

export default deleteStaffAccountApi;
